import { idbGet, idbSet, idbRemove } from '@/shared/IndexedDBHelper'

export class UserDevice {

    id: string;
    name?: string;
    type: string;
    osVersion: string;
    appVersion: string;
    language: string;
    updateTimestamp: number;
    notificationToken?: string;

    constructor(id: string, name: string | undefined, type: string, osVersion: string, appVersion: string, updateTimestamp: number, language: string, notificationToken: string | undefined) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.osVersion = osVersion;
        this.appVersion = appVersion;
        this.updateTimestamp = updateTimestamp;
        this.language = language;
        this.notificationToken = notificationToken;
    }
    
    get lastUpdate(): Date {
        return new Date(this.updateTimestamp * 1000);
    }

    async save() {
        if (!this.isCurrentDevice()) {
            return;
        }
        console.log("sync: save current device locally");
        this.updateTimestamp = Math.round(Date.now() / 1000);

        await idbSet('kCurrentDevice', {
            id: this.id,
            name: this.name ?? '',
            updateTimestamp: this.updateTimestamp
        });
    }

    isCurrentDevice(): boolean {
        return UserDevice.current.id === this.id;
    }

    static current: UserDevice = new UserDevice(
        'web',
        '',
        'web',
        navigator.userAgent,
        '1.0.0',
        Math.round(Date.now() / 1000),
        navigator.language,
        undefined
    );

    static async load(): Promise<void> {
        const saved = await idbGet<{ id: string; name: string; updateTimestamp: number }>('kCurrentDevice');
        if (saved) {
            this.current = new UserDevice(
                saved.id,
                saved.name,
                'web',
                navigator.userAgent,
                '1.0.0',
                saved.updateTimestamp,
                navigator.language,
                undefined
            );
        }
    }

    static recreateCurrentDevice() {
        console.log("sync: recreating new cloud device");
        idbRemove('kCurrentDevice').catch(() => {});
        UserDevice.current = new UserDevice(
            'web',
            '',
            'web',
            navigator.userAgent,
            '1.0.0',
            Math.round(Date.now() / 1000),
            navigator.language,
            undefined
        );
    }

    get typeName(): string {
        return "web"
    }

    toString(): string {
        return `device id: ${this.id}, type: ${this.type}, type name: ${this.typeName}, last update: ${this.lastUpdate}`;
    }

    toJSON(): any {
        return {
            id: this.id,
            name: this.name,
            type: this.type,
            osVersion: this.osVersion,
            appVersion: this.appVersion,
            updateTimestamp: this.updateTimestamp,
            language: this.language,
            notificationToken: this.notificationToken
        };
    }

    static fromJSON(data: any): UserDevice {
        const json = (typeof data === 'string') ? JSON.parse(data) : data;
        return new UserDevice(
            json.id,
            json.name,
            json.type,
            json.osVersion,
            json.appVersion,
            json.updateTimestamp,
            json.language,
            json.notificationToken
        );
    }

}

void UserDevice.load();
